<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="mb-3">
      Step 1: Contact Information
    </h2>
    <div class="mb-5 md:text-base text-sm">
      <p class="mb-3">
        <strong>By registering:</strong>
        <ul class="list-disc list-inside">
          <li>The project will be on QCP’s radar.</li>
          <li>A project number is generated for all parties to use throughout the project.</li>
          <li>Important project documents, reports, and correspondence will be housed in our database — to reference these in the future contact our team.</li>
        </ul>
      </p>
      <p class="mb-5">
        <a href="https://awiqcp.org/contact/">Contact our staff</a> with any administrative or technical question related to a QCP project.
      </p>
    </div>
    <form class="pt-5" @submit.prevent="passes(goToNextPage)">
      <div class="flex flex-wrap -mx-5">
        <d-field label="Your Full Name" class="w-full md:w-1/2 px-5">
          <d-input v-model="submitterName" aria-label="Full name" placeholder="First & Last Name" required />
        </d-field>
        <d-field label="Your Email" rules="required|email" class="w-full md:w-1/2 px-5">
          <d-input v-model="submitterEmail" aria-label="Email" placeholder="Email" required type="email" />
        </d-field>
        <d-field label="Project Name" class="w-full md:w-1/2 px-5">
          <d-input v-model="projectName" aria-label="Project name" required />
        </d-field>
        <d-field label="Project Role" class="w-full md:w-1/2 px-5">
          <d-select v-model="submitterProjectRole" required expanded>
            <option value="" disabled>
              Please select an option
            </option>
            <option value="Architect">
              Architect
            </option>
            <option value="General Contractor">
              General Contractor
            </option>
            <option value="Woodworker">
              Woodworker
            </option>
          </d-select>
        </d-field>
      </div>

      <div class="flex flex-wrap -mx-5">
        <d-field v-if="submitterProjectRole !== 'General Contractor'" class="w-full md:w-1/2 px-5" rules="required" label="Do you have General Contractor information available?" vid="showContractorInfo" mode="passive">
          <div>
            <d-radio v-model="showContractorInfo" :native-value="true" name="showContractorInfo">
              Yes
            </d-radio>
            <d-radio v-model="showContractorInfo" :native-value="false" name="showContractorInfo">
              No
            </d-radio>
          </div>
        </d-field>

        <div class="w-full md:w-1/2 px-5">
          <d-field v-if="submitterProjectRole !== 'Woodworker'" rules="required" label="Do you have Woodworker information available?" vid="showWoodworkerInfo" mode="passive">
            <div>
              <d-radio v-model="showWoodworkerInfo" :native-value="true" name="showWoodworkerInfo">
                Yes
              </d-radio>
              <d-radio v-model="showWoodworkerInfo" :native-value="false" name="showWoodworkerInfo">
                No
              </d-radio>
            </div>
          </d-field>
          <div v-if="showWoodworkerInfo == false">
            Are you looking for a Woodworker? <a href="https://awiqcp.org/woodworkers/find-a-qcp-firm/" target="_blank">Search for one today</a>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap justify-center md:justify-end pt-10">
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '@resources/scripts/utilities/field.utilities';
  import { PROJECT_REGISTRATION_FORM } from '@resources/scripts/store/mutation-types';
  import { extend } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';

  const { mapActions } = createNamespacedHelpers('projectRegistrationForm');

  extend('required', {
    ...required,
    message: 'This field is required',
  });

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['projectName', 'submitterName', 'submitterEmail', 'submitterProjectRole', 'projectStandards', 'showContractorInfo', 'showWoodworkerInfo'],
        module: 'projectRegistrationForm',
        base: 'formFields',
        mutation: PROJECT_REGISTRATION_FORM.FORM_FIELDS,
      }),
    },

    watch: {
      submitterProjectRole(val) {
        if (val === 'Woodworker') {
          this.showWoodworkerInfo = true;
          this.showContractorInfo = this.showContractorInfo === false ? false : null;
        } else if (val === 'General Contractor') {
          this.showContractorInfo = true;
          this.showWoodworkerInfo = this.showWoodworkerInfo === false ? false : null;
        } else {
          this.showContractorInfo = this.showContractorInfo === false ? false : null;
          this.showWoodworkerInfo = this.showWoodworkerInfo === false ? false : null;
        }
      },
    },

    methods: {
      ...mapActions([
        'goToNextPage',
      ]),
    },
  };
</script>